import { initMainMenuPopup } from "./main-menu-popup";
import { initCatsAndExpertsColumns } from "./cats-and-experts-columns";
import { initTileLinks } from "./tile-links";
import { initSliderDynamicNav } from "./slider-dynamic-nav";
import { initVideoTiles } from "./video-tiles";
import { initGoogleTranslateBtn } from "./google-translate-btn";
import { initCf7OptIn } from "./cf7-opt-in";
import { initPostTypeCookie } from "./post-type-cookie";
import { initSpecialBanner } from "./special-banner";
import { initPostTypeCookieSwitches } from "./post-type-cookie-switch";
import { initInputs } from "./inputs";
import { initListingPageInputs } from "./listing-page-inputs";
import { setCookieFromUrlHash } from "./post-type-cookie";
import { initSupplierSingle } from "./supplier-single";
import { initProductSingle } from "./product-single";
import { initEventSingle } from "./event-single";
import { initPostSingle } from "./post-single";
import { initAddForms } from "./add-form";
import { initDateInputs } from "./date-inputs";
import { initCheckboxToggle } from "./checkbox-toggle";
import { initSupplierAccountForms } from "./supplier-account";
import { initSearchPage } from "./search-page";
import { initSearchSuggestions } from "./search-suggestions";
import { initPostsPage } from "./posts-page";
import { initSupplierContactPopup } from "./supplier-contact-popup";

const hideAllPopups: Function = window["iw"].popups.hideAllPopups;
const keepInProportionUsingAttrs: Function = window["iw"].layout.keepInProportionUsingAttrs;

declare const jQuery: any;
const $ = jQuery;

// banner content
$(".banner").each(function () {
    const $banner = $(this);
    setTimeout(() => {
        $banner.addClass("reveal-content");
    }, 800);
});

// Main Menu Popup anim
$(".popup.popup-main-menu").on("opening", function () {
    const $popup = $(this);
    $popup.css({ transform: `translateX(100%)`, opacity: 0 });
    $popup.find(".popup-close-wrap").css({ opacity: 0 });
    setTimeout(() => {
        $popup.css({ transform: `none`, opacity: 1 });
        $popup.find(".popup-close-wrap").css({ opacity: 1 });
    }, 50);
}).on("closing", function () {
    const $popup = $(this);
    $popup.css({ display: "none" });
});

// Enquiry form popup click-off to close
$(`[data-popup="enquiry"]`).each(function () {
    const $popup = $(this).on("click", function (event) {
        $popup.trigger("close");
        return false;
    });
    $popup.find(".popup-main").on("click", function (event) {
        event.stopPropagation();
    });
});

// Custom select layout workaround
$($ => {
    const $body = $(document.body);
    $(".custom-select").on("opened", () => {
        $body.addClass("custom-select-open");
    }).on("closed", () => {
        $body.removeClass("custom-select-open");
    });
});

// "#suppiers" and "#products" -containing links (for switching cookie value) won't work
// if the preceding URL is the current URL, hence this fix:
$(`ul.menu a[href*="#"], .main-header-menu a[href*="#"]`).each(function () {
    const $link = $(this);
    const url: string = $link.attr("href");
    if (!url.match(/\#(products)|(suppliers)\b/))
    {
        return;
    }
    const path: string = url.split(/\#/g)[0].replace(/^https?\:\/+[\w\-\.]+/gi, "").replace(/(^\/+)|(\/+$)/g, "");
    const currPath: string = window.location.pathname.replace(/(^\/+)|(\/+$)/g, "");
    if (path !== currPath)
    {
        return;
    }
    $link.off("click").on("click", function (event): false {
        event.preventDefault();
        hideAllPopups();
        window.location.href = url;
        setCookieFromUrlHash();
        return false;
    });
});

$(`.slider iframe`).each(function () {
    keepInProportionUsingAttrs($(this));
});

// Supplier News Archive
$(`body.supplier-news-archive`).each(function () {
    const $loadMoreBtn = $(`[data-load-more-button]`);
    if ($loadMoreBtn.length === 0)
    {
        return;
    }
    const supplierId: number = window["iw"].newsArchiveSupplierId;
    if (!supplierId)
    {
        console.error(`window.iw.newsArchiveSupplierId missing`);
        return;
    }
    $loadMoreBtn.trigger("updatesetting", { customData: { supplierId } });
});

// Contact form popup - close on successful form submission
$(`.popup.cf`).each(function () {
    const $popup = $(this);
    document.addEventListener("wpcf7mailsent", function (e) {
        setTimeout(() => {
            $popup.trigger("close");
        }, 5000);
        $popup.find(".cf-inputs").css({ display: "none" });
    });
});


initMainMenuPopup();
initDateInputs();
initAddForms();
initCatsAndExpertsColumns();
initTileLinks();
initSliderDynamicNav();
initVideoTiles();
initGoogleTranslateBtn();
initCf7OptIn();
initSpecialBanner();
initPostTypeCookieSwitches(); // must come before initPostTypeCookie()
initPostTypeCookie();
initInputs();
initListingPageInputs(); // must come after initInputs()
initSupplierSingle(); // must come after initInputs()
initProductSingle(); // must come after initInputs()
initEventSingle();
initPostSingle();
initCheckboxToggle();
initSupplierAccountForms();
initSearchPage();
initSearchSuggestions();
initPostsPage();

// Disable enquiry form submit on proposal preview routes
$($ => {
    if (window["iw"]?.onProposalPreviewRoute)
    {
        $(`.hs-custom-post-single-main [data-expert-contact], .hs-enquiry-form [data-submit]`).off("click").on("click", function (event) {
            alert("Enquiry forms are disabled while previewing your posts!");
            event.preventDefault();
            event.stopPropagation();
            return false;
        });
        $(`.hs-supplier-news-section-body a.button[href*="?post_type=supplier&p="]`).on("click", function (event) {
            alert(`News page link is only available via your published profile page`);
            event.preventDefault();
            event.stopPropagation();
            return false;
        });
    }
});

$(`body.single-post .post-content`).each(function () {
    const $wrap = $(this);
    const maxWidth: number = $wrap.width() - 30;
    $wrap.find(`img[width][height]`).each(function () {
        const $img = $(this);
        const width = parseInt($img.attr("width"), 10);
        const height = parseInt($img.attr("height"), 10);
        if (width && height && width <= maxWidth) {
            $img.css({ width, height });
        }
    });
});

initSupplierContactPopup();
